import { render } from "./Level2Org.vue?vue&type=template&id=1753aba0&scoped=true"
import script from "./Level2Org.vue?vue&type=script&lang=js"
export * from "./Level2Org.vue?vue&type=script&lang=js"

import "./Level2Org.vue?vue&type=style&index=0&id=1753aba0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1753aba0"]])

export default __exports__